<template>
  <task-detail typeTitle="水样对比"></task-detail>
</template>

<script>
import taskDetail from '../components/taskDetail.vue';
export default {
  components: {
    taskDetail
  },
}
</script>
